import {Button} from '@material-ui/core';
import {changePassword, changeUsername, login} from 'ApplicationEntry/ducks/AWDLogin';
import {
  InvalidAWDLogin,
  UnvalidatedAWDLogin,
  ValidAWDLogin,
  UnsuccessfulAWDLogin,
  matchAWDLogin,
} from 'ApplicationEntry/models/AWDLogin';
import React from 'react';
import {useDispatch} from 'react-redux';
import RequiredTextInput from 'Shared/components/RequiredTextInput';
import Alert from 'Shared/components/Alert';

type AWDLoginFormProps = {
  awdLogin: UnvalidatedAWDLogin | InvalidAWDLogin | ValidAWDLogin | UnsuccessfulAWDLogin;
};

const AWDLoginForm = (props: AWDLoginFormProps) => {
  const {awdLogin} = props;
  const {username, password} = awdLogin;
  const dispatch = useDispatch();
  const isAllowedToSave = matchAWDLogin(awdLogin, {
    ValidAWDLogin: () => true,
    default: () => false,
  });
  const onSave = () => {
    matchAWDLogin(awdLogin, {
      ValidAWDLogin: validAwdLogin => dispatch(login(validAwdLogin)),
      default: () => {},
    });
  };

  return (
    <form className="awd-login-form">
      {matchAWDLogin(awdLogin, {
        UnsuccessfulAWDLogin: () => (
          <Alert message="Login was unsuccessful. Please verify your username and password are correct and try again." />
        ),
        default: () => null,
      })}
      <h1 className="awd-login-form__title">Sign in below</h1>
      <p className="awd-login-form__description">
        In order to enter new applications, you will need to enter your AWD credentials one time to start your session.
      </p>
      <RequiredTextInput
        className="awd-login-form__password-input"
        label="Username"
        value={username}
        onChange={username => dispatch(changeUsername(username.value))}
      />
      <RequiredTextInput
        className="awd-login-form__password-input"
        label="Password"
        value={password}
        onChange={password => dispatch(changePassword(password.value))}
        inputProps={{
          type: 'password',
        }}
      />
      <Button
        className="awd-login-form__sign-in-button"
        fullWidth
        type="submit"
        variant="contained"
        color="secondary"
        disabled={!isAllowedToSave}
        onClick={onSave}
      >
        Sign In
      </Button>
    </form>
  );
};

export default AWDLoginForm;
